import { Directive, Input, OnDestroy, OnInit, Renderer2 } from '@angular/core'
import { IonContent } from '@ionic/angular'
import { Subscription } from 'rxjs'

@Directive({ selector: '[buttonToggleOnScroll]' })
export class ButtonToggleOnScrollDirective implements OnInit, OnDestroy {
  @Input('ionContent') ionContent: IonContent | undefined
  @Input('buttonToggleOnScroll') button: any | undefined
  private prevScrollY = 0
  private direction: 'up' | 'down' = 'up'
  private scrollSubscription: Subscription | undefined

  constructor(private renderer: Renderer2) {}

  ngOnInit(): void {}

  ngOnChanges(): void {
    if (this.ionContent !== undefined && this.scrollSubscription === undefined) {
      this.scrollSubscription = this.ionContent?.ionScroll.subscribe(async (event) => {
        const newScrollY = event.detail.scrollTop
        // 위로 overscrolling 했을 때는 동작하지 않도록
        if (newScrollY < 0) return
        const newDirection = this.prevScrollY < newScrollY ? 'down' : 'up'
        const containerElem = await this.ionContent?.getScrollElement()
        // 아래로 overscrolling 했을 때는 동작하지 않도록
        if (containerElem !== undefined && containerElem.scrollHeight < window.innerHeight + newScrollY) {
          return
        }
        this.prevScrollY = newScrollY
        if (this.direction !== newDirection) {
          this.direction = newDirection
          this.toggleButton(newDirection)
        }
      })
    }
  }

  ngOnDestroy(): void {
    this.scrollSubscription?.unsubscribe()
  }

  private toggleButton(direction: 'up' | 'down'): void {
    if (!this.button) return
    // ion-fab일 경우 el에 접근해야 함
    const elem = this.button.el ? this.button.el : this.button
    if (direction === 'up') {
      this.renderer.removeClass(elem, 'hide-fixed-button')
      this.renderer.addClass(elem, 'show-fixed-button')
    } else {
      this.renderer.removeClass(elem, 'show-fixed-button')
      this.renderer.addClass(elem, 'hide-fixed-button')
    }
  }
}
